module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADRJREFUeNpcjAEKADAIAtP//9nVmGATQvBSSqqWxvMI4BK7xaZ4FSzwh24yv3J2gZw9AgwAGZEj/RsjMkMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/img/overlays/08.png
// module id = ../../../../../src/img/overlays/08.png
// module chunks = 1